import { render, staticRenderFns } from "./ProgressOrder.vue?vue&type=template&id=6bc42571&scoped=true&"
import script from "./ProgressOrder.vue?vue&type=script&lang=js&"
export * from "./ProgressOrder.vue?vue&type=script&lang=js&"
import style0 from "./ProgressOrder.vue?vue&type=style&index=0&id=6bc42571&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc42571",
  null
  
)

export default component.exports